import axios from 'axios';
import {
  GET_VEHICLE_IMAGE,
  GET_VEHICLE_SITECORE_DETAILS,
  GET_VEHICLE_IMAGES,
  GET_VEHICLE_COLOURS,
  EXT_360,
  INT_360,
  apiConfig,
} from './constants';
import {
  VehicleImageDataResponse,
  VehicleSiteCoreDetailsResponse,
  VehicleColourOptionsDataResponse,
  ExteriorResponse,
  InteriorResponse,
} from '../type';
import { Exterior, Interior, VehicleSiteCoreDetails } from 'interface';

/**
 * Function to fetch the image url of the vehicle based on cap model code doors trim and doors.
 * @param {string} modelCode of the vehicle.
 * @param {number} doors of the vehicle.
 * @param {string} trim of the vehicle.
 * @param {string} train of the vehicle.
 */
export const getVehicleImage = (
  modelCode: number | undefined,
  doors: number | undefined,
  trim: string | undefined,
  train: string | undefined,
  year: string | undefined
) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get<number, VehicleImageDataResponse>(
          GET_VEHICLE_IMAGE(modelCode, doors, trim, train, year),
          apiConfig
        )
        .then((res) => {
          const { data } = res;

          resolve(data);
        })
        .catch(() => {
          reject('Error in getVehicleImage axios.');
        });
    } catch (error) {
      console.error('in vehicleService > getVehicleImage, Err===', error);
      reject('System error. Please try again later.');
    }
  });
};

/**
 * Function to fetch the tags of the vehicle based on id.
 * @param {string} id of the vehicle.
 */
export const getVehicleSiteCoreDetails = (id: number) => {
  return new Promise<VehicleSiteCoreDetails>((resolve, reject) => {
    try {
      axios
        .get<number, VehicleSiteCoreDetailsResponse>(
          GET_VEHICLE_SITECORE_DETAILS(id)
        )
        .then((res) => {
          const { data } = res;
          resolve(data);
        })
        .catch(() => {
          reject('Error in getVehicleSiteCoreDetails axios.');
        });
    } catch (error) {
      console.error(
        'in vehicleService > getVehicleSiteCoreDetails, Err===',
        error
      );
    }
  });
};

/**
 * Function to fetch the gallery images of the vehicle based on cap model code doors trim and doors.
 * @param {string} modelCode of the vehicle.
 * @param {number} doors of the vehicle.
 * @param {string} trim of the vehicle.
 * @param {string} train of the vehicle.
 * @param {string} year of the vehicle.
 */
export const getVehicleImages = (
  modelCode: number | undefined,
  doors: number | undefined,
  trim: string | undefined,
  train: string | undefined,
  year: string | undefined
) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get<number, VehicleImageDataResponse>(
          GET_VEHICLE_IMAGES(modelCode, doors, trim, train, year),
          apiConfig
        )
        .then((res) => {
          const { data } = res;

          resolve(data);
        })
        .catch(() => {
          reject('Error in getVehicleImages axios.');
        });
    } catch (error) {
      console.error('in vehicleService > getVehicleImages, Err===', error);
      reject('System error. Please try again later.');
    }
  });
};

/**
 * Function to fetch the colour options of the vehicle based on cap model code doors trim and doors.
 * @param {string} modelCode of the vehicle.
 * @param {number} doors of the vehicle.
 * @param {string} trim of the vehicle.
 * @param {string} train of the vehicle.
 */
export const getVehicleColours = (
  modelCode: number | undefined,
  doors: number | undefined,
  trim: string | undefined,
  train: string | undefined,
  year: string | undefined
) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get<number, VehicleColourOptionsDataResponse>(
          GET_VEHICLE_COLOURS(modelCode, doors, trim, train, year),
          apiConfig
        )
        .then((res) => {
          const { data } = res;

          resolve(data);
        })
        .catch(() => {
          reject('Error in getVehicleColours axios.');
        });
    } catch (error) {
      console.error('in vehicleService > getVehicleColours, Err===', error);
      reject('System error. Please try again later.');
    }
  });
};

/**
 * Function to fetch images for external 360 view
 * @param {string} modelCode of the vehicle.
 * @param {number} doors of the vehicle.
 * @param {string} trim of the vehicle.
 * @param {string} train of the vehicle.
 */
export const getVehicleExterior = (
  modelCode: number | undefined,
  doors: number | undefined,
  trim: string | undefined,
  train: string | undefined,
  year: string | undefined
) => {
  return new Promise<Exterior[]>((resolve, reject) => {
    try {
      axios
        .get<number, ExteriorResponse>(
          EXT_360(modelCode, doors, trim, train, year),
          apiConfig
        )
        .then((res) => {
          const { data } = res;
          resolve(data);
        })
        .catch(() => {
          reject('Error in getVehicleExterior axios.');
        });
    } catch (error) {
      console.error('in vehicleService > getVehicleExterior, Err===', error);
    }
  });
};

/**
 * Function to fetch images for internal 360 view
 * @param {string} modelCode of the vehicle.
 * @param {number} doors of the vehicle.
 * @param {string} trim of the vehicle.
 * @param {string} train of the vehicle.
 */
export const getVehicleInterior = (
  modelCode: number | undefined,
  doors: number | undefined,
  trim: string | undefined,
  train: string | undefined,
  year: string | undefined
) => {
  return new Promise<Interior>((resolve, reject) => {
    try {
      axios
        .get<number, InteriorResponse>(
          INT_360(modelCode, doors, trim, train, year),
          apiConfig
        )
        .then((res) => {
          resolve(res.data[0]);
        })
        .catch(() => {
          reject('Error in getVehicleInterior axios.');
        });
    } catch (error) {
      console.error('in vehicleService > getVehicleInterior, Err===', error);
    }
  });
};
